import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const SchengenCPage = () => {
  useEffect(() => {
    document.title = 'Schengen C Tipi Vize | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Schengen C tipi vize başvuruları için profesyonel danışmanlık. Turistik, ticari ve aile ziyareti vizelerinde 10+ yıl deneyim ile yanınızdayız.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/2e8338b2648309db66c0a3fbfbd5aa1e.jpg"
              alt="Schengen C Vize"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              Schengen Vizesi
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Schengen C Tipi Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Turistik, ticari ve aile ziyareti amaçlı kısa süreli Schengen vizelerinde profesyonel destek
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Schengen C Tipi Vize Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Schengen C tipi vize, Schengen bölgesine kısa süreli seyahatler için düzenlenen vize türüdür. Bu vize ile 180 gün içerisinde maksimum 90 gün kalış hakkı elde edilir. Turistik geziler, iş görüşmeleri, konferanslar, aile ziyaretleri ve kısa süreli eğitim programları için başvurulabilir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                Schengen bölgesi 27 Avrupa ülkesini kapsayan bir serbest dolaşım alanıdır. Tek bir Schengen vizesi ile bu ülkelerin tamamına seyahat edebilirsiniz. Ancak başvurunuzu, en uzun süre kalacağınız veya ilk giriş yapacağınız ülkenin konsolosluğuna yapmanız gerekmektedir.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Schengen C Vizesi Türleri
              </h2>
              <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8">
                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-plane-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Turistik Vize</h3>
                  <p className="text-navy-600 text-sm">Tatil, gezi ve turizm amaçlı seyahatler için düzenlenir.</p>
                </div>
                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-briefcase-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Ticari Vize</h3>
                  <p className="text-navy-600 text-sm">İş görüşmeleri, konferans ve fuarlar için kullanılır.</p>
                </div>
                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-group-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Aile Ziyareti</h3>
                  <p className="text-navy-600 text-sm">Akraba ve arkadaş ziyaretleri için düzenlenir.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Gerekli Evraklar
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <ul className="space-y-3 text-cream-100">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Pasaport:</strong> En az 6 ay geçerlilik süresi olan, en az 2 boş sayfası bulunan pasaport</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Vize Başvuru Formu:</strong> Eksiksiz ve doğru doldurulmuş başvuru formu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Fotoğraf:</strong> Biyometrik fotoğraf standartlarına uygun 2 adet renkli fotoğraf</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Seyahat Sigortası:</strong> Minimum 30.000 Euro teminatı olan sağlık sigortası</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Uçak Bileti:</strong> Gidiş-dönüş rezervasyon belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Konaklama Belgesi:</strong> Otel rezervasyonu veya davetiye mektubu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Mali Durum Belgeleri:</strong> Banka hesap özeti, maaş bordrosu, SGK hizmet dökümü</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>İş Belgesi:</strong> Çalışma durumunu gösteren belgeler (çalışan, emekli, öğrenci vb.)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Medeni Durum Belgeleri:</strong> Evlilik cüzdanı, nüfus kayıt örneği</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Ön Değerlendirme ve Danışmanlık</h3>
                    <p className="text-navy-600">Seyahat amacınız, profiliniz ve gideceğiniz ülke detaylı şekilde analiz edilir. Size özel evrak listesi hazırlanır.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Hazırlığı ve Kontrolü</h3>
                    <p className="text-navy-600">Tüm belgeleriniz konsolosluk kriterlerine uygun şekilde hazırlanır ve detaylı kontrol edilir.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Randevu Alımı</h3>
                    <p className="text-navy-600">Konsolosluk veya vize başvuru merkezinden randevu alınır ve size bildirilir.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Başvuru ve Biyometrik İşlemler</h3>
                    <p className="text-navy-600">Randevu gününde başvuru merkezi veya konsolosluğa giderek başvurunuzu tamamlarsınız.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-cream-50 rounded-xl p-4 md:p-6">
                  <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-cream-100 font-bold">5</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-navy-900 text-lg mb-2">Takip ve Sonuçlandırma</h3>
                    <p className="text-navy-600">Başvurunuz sürekli takip edilir ve sonuçlandığında size bildirilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Schengen Ülkeleri
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-4">
                Schengen C tipi vize ile aşağıdaki ülkelere seyahat edebilirsiniz:
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8">
                {['Almanya', 'Avusturya', 'Belçika', 'Çekya', 'Danimarka', 'Estonya', 'Finlandiya', 'Fransa', 'Hollanda', 'İspanya', 'İsveç', 'İsviçre', 'İtalya', 'İzlanda', 'Letonya', 'Litvanya', 'Lüksemburg', 'Macaristan', 'Malta', 'Norveç', 'Polonya', 'Portekiz', 'Slovakya', 'Slovenya', 'Yunanistan'].map((country) => (
                  <div key={country} className="flex items-center gap-2 text-navy-700">
                    <i className="ri-map-pin-fill text-cream-400"></i>
                    <span>{country}</span>
                  </div>
                ))}
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Neden Profesyonel Danışmanlık?
              </h2>
              <div className="bg-cream-50 rounded-2xl p-6 md:p-8 mb-8">
                <ul className="space-y-3 text-navy-700">
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Yüksek Onay Oranı:</strong> 10+ yıllık deneyimimiz ile başvurularınızı en güçlü şekilde hazırlıyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Zaman Tasarrufu:</strong> Tüm evrak hazırlığı ve randevu işlemlerini sizin adınıza yönetiyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Hata Riski Minimumu:</strong> Eksik veya hatalı evrak nedeniyle ret riskini ortadan kaldırıyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Güncel Bilgi:</strong> Konsolosluk prosedürlerindeki değişiklikleri takip ediyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>İade Garantisi:</strong> Belirli koşullarda iade garantisi sunuyoruz</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Schengen vizesi kaç günde çıkar?</h3>
                  <p className="text-navy-600">Başvuru sonrası ortalama 10-15 iş günü içerisinde sonuçlanır. Yoğun dönemlerde bu süre uzayabilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Hesapta ne kadar para olmalı?</h3>
                  <p className="text-navy-600">Günlük minimum 50-70 Euro karşılığı bakiye gösterilmesi önerilir. Kalış sürenize göre değişiklik gösterebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Vize ücreti ne kadar?</h3>
                  <p className="text-navy-600">Konsolosluk vize ücreti 80 Euro'dur. Danışmanlık ücretimiz için bizimle iletişime geçebilirsiniz.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Vize reddedilirse ne olur?</h3>
                  <p className="text-navy-600">Ret nedenleri analiz edilerek yeniden başvuru yapılabilir. İade garantisi koşullarımız için danışın.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              Schengen Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              10+ yıllık deneyimimiz ile Schengen vize başvurunuzda yanınızdayız
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default SchengenCPage;